import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppRouter } from './AppRouter';
import './index.css';
// Get the root element
const container = document.getElementById('root');
// Make sure it exists before trying to render
if (container) {
  const root = createRoot(container);
  // Wrap the app in an error boundary at the highest level
  root.render(<React.StrictMode data-id="element-500">
      <AppRouter data-id="element-501" />
    </React.StrictMode>);
} else {
  console.error('Root element not found! Check your HTML file.');
}